import { z } from 'zod';
import { IsoDateTimeSchema } from './common';

/**
 * Lo que se puede archivar. Una sesión arrastra su propia fila y las dos
 * hijas que cuelgan de ella: las asistencias y las justificaciones.
 */
export const EntidadBorradaSchema = z.enum(['sesion', 'asistencia', 'justificacion']);
export type EntidadBorrada = z.infer<typeof EntidadBorradaSchema>;

/**
 * Una fila del archivo `borrados`: la copia íntegra de algo que se borró.
 *
 * `datos_json` es la fila original serializada completa, para que el archivo
 * sea autosuficiente y el borrado sea reversible a mano.
 */
export const BorradoSchema = z.object({
  id: z.string(),
  entidad: EntidadBorradaSchema,
  // La laxitud del id es INTENCIONAL: `sesion_id` y `borrado_por_usuario_id`
  // apuntan a filas heredadas que no son UUID (la misma razon que en
  // `UsuarioRowSchema.id` y `ActividadRowSchema.actor_id`).
  sesion_id: z.string(),
  resumen: z.string(),
  datos_json: z.string(),
  borrado_en: IsoDateTimeSchema,
  borrado_por_usuario_id: z.string().nullable(),
  motivo: z.string().nullable(),
  restaurado_en: IsoDateTimeSchema.nullable(),
});
export type Borrado = z.infer<typeof BorradoSchema>;

export const BorradoListResponseSchema = z.object({
  data: z.array(BorradoSchema),
  next_cursor: z.string().nullable().optional(),
});
export type BorradoListResponse = z.infer<typeof BorradoListResponseSchema>;

/**
 * Resumen de lo que se archivó al eliminar una sesión.
 */
export const ArchivadoResumenSchema = z.object({
  sesion: z.number().int().nonnegative(),
  asistencia: z.number().int().nonnegative(),
  justificacion: z.number().int().nonnegative(),
  total: z.number().int().nonnegative(),
});
export type ArchivadoResumen = z.infer<typeof ArchivadoResumenSchema>;

/**
 * Respuesta de DELETE /api/v1/sesiones/:id.
 */
export const SesionEliminarResponseSchema = z.object({
  ok: z.literal(true),
  archivados: ArchivadoResumenSchema,
});
export type SesionEliminarResponse = z.infer<typeof SesionEliminarResponseSchema>;
